import { gql } from '@apollo/client';

export const ADMIN_LOGIN1 = gql`
mutation adminLogin1($loginHandle : String!) {
  adminLogin1(loginHandle: $loginHandle) {
    status
    data
    error
  }
}
`;

export const ADMIN_LOGIN2 = gql`
mutation adminLogin2($loginHandle : String!, $code : String!, $fingerprint : String!) {
  adminLogin2(loginHandle: $loginHandle, code : $code, fingerprint : $fingerprint) {
    status
    error
    token
    dt
    a
  }
}
`;

export const CREATE_ADMIN_USER = gql`
mutation createAdminUser(
  $phone: String!,
  $name: String!,
  $username: String!,
  $email: String!,
  $enabled: Boolean!,
  $permissions: Float!,
) {
  createAdminUser(
    phone: $phone,
    name: $name,
    username: $username,
    email: $email,
    enabled: $enabled,
    permissions: $permissions,
  ) {
    status
    error
  }
}`;

export const UPDATE_ADMIN_USER = gql`
mutation updateAdminUser(
  $userid: String!,
  $phone: String!,
  $name: String!,
  $username: String!,
  $email: String!,
  $enabled: Boolean!,
  $permissions: Float!,
) {
  updateAdminUser(
    userid: $userid,
    phone: $phone,
    name: $name,
    username: $username,
    email: $email,
    enabled: $enabled,
    permissions: $permissions,
  ) {
    status
    error
    user {
      userid
      name
      phone
      username
      email
      enabled
      permissions
      datetimecreated
      datetimeupdated
    }
  }
}`;